export default {
    modelValue: {
        type: [String, Date],
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    value: {
        type: [String, Date],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateInput/DateInputProps.js